import React from 'react';
import { Tabs, TabContent } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import appStyles from 'Routes/Routes.css';
import Header from './components/Header';
import MerchantsOverridesTable from './components/MerchantsOverridesTable';

import styles from './Overrides.css';

const Overrides = () => {
    const { t } = useTranslation();

    return (
        <div className={appStyles.landingPage}>
            <Header />
            <Tabs className={styles.overridesTabs} startIndex={0} type='small'>
                <TabContent headerTestId='merchants-tab' hidden label={t('Subject_plural')}>
                    <MerchantsOverridesTable />
                </TabContent>
            </Tabs>
        </div>
    );
};

export default Overrides;
